import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { initializeIcons } from "@fluentui/react";

import "./index.css";

import Layout from "./pages/layout/Layout";
import NoPage from "./pages/NoPage";
import Chat from "./pages/chat/Chat";
import { AppStateProvider } from "./state/AppProvider";
import AuthStart from "./pages/auth/AuthStart";
import AuthEnd from "./pages/auth/AuthEnd";

initializeIcons();

export default function App() {
    return (
        <BrowserRouter>
            <Routes>
                {/* Auth routes - OUTSIDE AppStateProvider */}
                <Route path="/auth-start" element={<AuthStart />} />
                <Route path="/auth-end" element={<AuthEnd />} />
                
                {/* Main app routes - wrapped in AppStateProvider */}
                <Route path="/" element={
                  <AppStateProvider>
                      <Layout />
                  </AppStateProvider>
                }>
                    <Route index element={<Chat />} />
                    <Route path="*" element={<NoPage />} />
                </Route>
            </Routes>
        </BrowserRouter>
    );
}

ReactDOM.createRoot(document.getElementById("root") as HTMLElement).render(
    <React.StrictMode>
        <App />
    </React.StrictMode>
);
